import tomato from '../login page/hom1/vegetables/tomato.jpg'
import potato from '../login page/hom1/vegetables/potato.jfif'
import peas from '../login page/hom1/vegetables/peas.jpg'
import onion from '../login page/hom1/vegetables/onion.jpeg'
import bittergourd from '../login page/hom1/vegetables/bitter-gourd.jpg'
import coriander from '../login page/hom1/vegetables/coriander.jpeg'
import cauliflower from '../login page/hom1/vegetables/cauliflower.jpg'
import carrots from '../login page/hom1/vegetables/carrots.webp'
import cabbage from '../login page/hom1/vegetables/cabbage.jfif'
import beat from '../login page/hom1/vegetables/beat.jpg'
import springonion from '../login page/hom1/vegetables/springonion.jfif'
import capsicum from '../login page/hom1/vegetables/capsicum.png'
import corn from '../login page/hom1/vegetables/corn.jfif'
import cucumber from '../login page/hom1/vegetables/cucumber.jfif'
import eggplant from '../login page/hom1/vegetables/eggplant.jpg'
import ladyfinger from '../login page/hom1/vegetables/ladyfingers.jpg'
import wishlist1 from '../login page/hom1/wishlist1.jpg'
import wishlist2 from '../login page/hom1/wishlist2.jpg'
const Vdata = [
    {
        sname: "tomato",
        imgscr: tomato,
        title: "real veg",
        price: "10/-KG",
        oldprice1: "20/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "potato",
        imgscr: potato,
        title: "real veg",
        price: "15/-KG",
        oldprice1: "20/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "peas",
        imgscr: peas,
        title: "real veg",
        price: "25/-KG",
        oldprice1: "30/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "onion",
        imgscr: onion,
        title: "real veg",
        price: "35/-KG",
        oldprice1: "40/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "bittergourd",
        imgscr: bittergourd,
        title: "real veg",
        price: "45/-KG",
        oldprice1: "50/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "coriander",
        imgscr: coriander,
        title: "real veg",
        price: "55/-KG",
        oldprice1: "60/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "cauliflower",
        imgscr: cauliflower,
        title: "real veg",
        price: "65/-KG",
        oldprice1: "70/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "carrots",
        imgscr: carrots,
        title: "real veg",
        price: "75/-KG",
        oldprice1: "80/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "cabbage",
        imgscr: cabbage,
        title: "real veg",
        price: "10/-KG",
        oldprice1: "20/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "beat",
        imgscr: beat,
        title: "real veg",
        price: "15/-KG",
        oldprice1: "20/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "springonion",
        imgscr: springonion,
        title: "real veg",
        price: "25/-KG",
        oldprice1: "30/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "capsicum",
        imgscr: capsicum,
        title: "real veg",
        price: "35/-KG",
        oldprice1: "40/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "corn",
        imgscr: corn,
        title: "real veg",
        price: "45/-KG",
        oldprice1: "50/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "cucumber",
        imgscr: cucumber,
        title: "real veg",
        price: "15/-KG",
        oldprice1: "55/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "eggplant",
        imgscr: eggplant,
        title: "real veg",
        price: "35/-KG",
        oldprice1: "45/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
    {
        sname: "ladyfinger",
        imgscr: ladyfinger,
        title: "real veg",
        price: "55/-KG",
        oldprice1: "65/-KG",
        wishlist11: wishlist1,
        wishlist21: wishlist2
    },
]

export default Vdata